import { AccountTreeRounded, Approval, Rule, UploadFileSharp } from '@mui/icons-material'
import { Button, IconButton, Tooltip } from '@mui/material'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import useContract from 'store/contracts'
import ModalReviewMovements from './modal-review'
import ModalExportSeller from './modal-seller'
import ContractViewProcessTable from './table'
import { IMovimentacaoResponse } from '../..'
import api from 'services/api'
import dayjs from 'dayjs'

interface IProps {
  organizationId: string
  projects: IProjectDTO[]
  dataProps: {
    movimentacao: string; //"Inclusão" | "Demissão" | "Transferência" | "Alteração";
    cpf: string;
    cpfDependente: string;
    nome: string;
    parentesco: string; //"Titular" | "Dependente";
    plano: string;
    cargo: string;
    dataAdmissao: string;
    dataDemissao: string;
    municipio: string;
    registrationNumber: string;
  }[],
  metrics: {
    "total": number,
    "Inclusão": number,
    "Demissão": number,
    "Alteração": number,
    "Transferência": number
  }
  ultimaAtualizacao: string
  approvalDate: string
  isSeller?: boolean
  handleChangeStepper: (step: number) => void
  setViewMode: (view: 'table' | 'grid') => void
}

const StepPending = ({ organizationId, projects, dataProps, metrics, handleChangeStepper, ultimaAtualizacao, approvalDate, isSeller, setViewMode }: IProps) => {
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const { contractId, tagId } = useParams<{ contractId: string, tagId: string }>();
  const history = useHistory();
  const location = history.location.pathname;

  const adesoesRedirect = () => {
    const app = projects
      .map((project) => ({
        projectId: project.id,
        recipe: project.recipes.find(
          (recipe) => recipe.position === 6 && recipe.type === 'app' && recipe.appName === 'Adesões'
        ),
      }))
      .filter(({ recipe }) => recipe !== undefined)

    if (app[0]) {
      history.push(//:contractId/:tagId
        `/projects/movimentacao/${app[0].projectId}/app/${app[0].recipe?.id}/${organizationId}/${contractId}/${tagId}?callback=${location.trim()}`
      )
    }
  }

  const exceptionsRedirect = () => {
    const app = projects
      .map((project) => ({
        projectId: project.id,
        recipe: project.recipes.find(
          (recipe) => recipe.position === 3 && recipe.type === 'app' && recipe.appName === 'Exceções'
        ),
      }))
      .filter(({ recipe }) => recipe !== undefined)

    if (app[0]) {
      history.push(//:contractId/:tagId
        `/projects/movimentacao/${app[0].projectId}/app/${app[0].recipe?.id}/${organizationId}/${contractId}/${tagId}?callback=${location.trim()}`
      )
    }
  }

  function formatDate(dateToFormat: string) {
    try {
      if (!dayjs(dateToFormat).isValid()) throw new Error();
      
      return dayjs(dateToFormat).format(`DD/MM/YYYY - HH:mm:ss`); //Converte para horário local
    } catch (error) {
      return `--/--/---- --:--:--`
    }
  }

  const formattedDate = formatDate(ultimaAtualizacao);
  const formattedApprovalDate = formatDate(approvalDate);

  return (
    <>
      <ModalReviewMovements
        open={reviewModalOpen}
        setChangeState={() => {
          setReviewModalOpen((prev) => !prev)
          handleChangeStepper(1)
        }}
        handleClose={() => setReviewModalOpen((prev) => !prev)}
        data={{ ultimaAtualizacao, project: projects.find(project => project.name === 'Minhas compras') ?? projects[0] }}
      />
      <ModalExportSeller
        open={exportModalOpen}
        setChangeState={() => {
          setExportModalOpen((prev) => !prev)
          // handleChangeStepper(1)
        }}
        handleClose={() => setExportModalOpen((prev) => !prev)}
        data={{ ultimaAtualizacao, isSeller: isSeller ? isSeller : false }}
        project={projects.find(project => project.name === 'Exportação de informação') ?? projects[0]}
      />
      <div style={{ width: '100%', padding: '24px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', gap: '12px', borderRadius: '8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600,marginBottom: '24px'}}>Movimentações</h1>

          {/** Botoes a direita (grid, table, etc) */}
          <div style={{"display":"flex","gap":"0.25rem"}}>
            <Tooltip title='Modo detalhado'>
              <IconButton onClick={() => setViewMode('grid')}>
                <AccountTreeRounded />
              </IconButton>
            </Tooltip>
          </div>
        </div>

        {/** Interface de Data */}
        <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Dados atualizados em</p>
            <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{formattedDate}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' }}>
            <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Última movimentação aprovada</p>
            <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{formattedApprovalDate}</span>
          </div>
        </div>


        {/** Métricas (Total, Inclusoes, etc) */}
        <div style={{"display":"flex","gap":"1rem"}}>
          {Object.entries(metrics).map(([title, value]) => (
            <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column', marginBottom: '30px' }}>
              <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>{title}</p>
              <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78' }}>{value}</span>
            </div>
          ))}
        </div>

        {/** Tabela e filtros */}
        <ContractViewProcessTable data={dataProps} />

        {/** Navegacao em baixo (Adesões, Revisar) */}
        {!isSeller && (
          <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end',"paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"24px" }}>
            <div style={{display: 'flex',"gap":"0.25rem"}}>
              <Button
                variant='text'
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                onClick={() => exceptionsRedirect()}
              >
                Exceções
              </Button>

              <Button
                variant='text'
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                onClick={() => adesoesRedirect()}
              >
                Adesões
              </Button>

              <Button
                variant='contained'
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                onClick={() => setReviewModalOpen(true)}
              >
                Aprovar
              </Button>
            </div>
          </div>
        )}
        {isSeller && (
          <div style={{"display":"flex","paddingTop":"0.5rem","paddingBottom":"0.5rem","justifyContent":"flex-end","alignItems":"center","width":"100%","marginTop":"24px"}}>
            <Button
              variant='contained'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={() => {
                
                setExportModalOpen(true)
              }}
            >
              Exportar arquivo
            </Button>
          </div>
        )}
      </div>
    </>
  )
}

export default StepPending
